function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "qrebto2zza",
  d: "M0 0h16.922v19.34H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bz9jvtplyc",
  d: "M0 0h16.922v19.34H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(9 2.017 25.63)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mgi6erubjb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#qrebto2zza"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.304 7.438c-3.98 3.346-7.536 6.512-8.531 11.901C6.64 16.641 11.757 16 14.468 12.737 17.267 9.37 16.77 4.713 16.922 0c-3.256 1.547-6.48 2.403-9.78 3.162-6.314 1.451-8.986 8.323-5.783 14.71 3.548-6.417 6.123-9.21 9.945-10.434z",
  fill: "#0E4816",
  fillRule: "nonzero",
  mask: "url(#mgi6erubjb)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1.204)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "yotboafakd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bz9jvtplyc"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.304 7.438c-3.98 3.346-7.536 6.512-8.531 11.901C6.64 16.641 11.757 16 14.468 12.737 17.267 9.37 16.77 4.713 16.922 0c-3.256 1.547-6.48 2.403-9.78 3.162-6.314 1.451-8.986 8.323-5.783 14.71 3.548-6.417 6.123-9.21 9.945-10.434z",
  fill: "#589D62",
  fillRule: "nonzero",
  mask: "url(#yotboafakd)"
})));

var SvgGreenLeaf = function SvgGreenLeaf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGreenLeaf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/green-leaf.b8fce268.svg";
export { ForwardRef as ReactComponent };